import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import TopNav from "../TopNav";
import Loading from "../StyledComponents/Loading";
import PrescriptionTab from "./PrescriptionTab";
import RefillRequest from "./RefillRequest";

import { BodyContainer } from "../StyledComponents";
import { Div } from "./styles";

const Prescription = () => {
  const { state } = useLocation();

  const [activeTab, setActiveTab] = useState("Prescription");
  const [showAddModal, setShowAddModal] = useState(false);

  return (
    <>
      <TopNav title="Prescription" />

      {false ? (
        <Loading />
      ) : (
        <BodyContainer
          paddingLeft="10px"
          paddingTop="2px"
          // style={{
          //   background: "#8e8e8e40",
          //   minHeight: "100vh",
          // }}
        >
          {/* Tabs Header */}
          <Div
            display="flex"
            borderBottom="1px solid #E5E7EB"
            background="transparent "
          >
            <Div
              background="transparent "
              padding="14px 20px"
              cursor="pointer"
              borderBottom={
                activeTab === "Prescription" ? "2px solid #2C7BE5" : "none"
              }
              fontWeight={activeTab === "Prescription" ? "600" : "400"}
              onClick={() => setActiveTab("Prescription")}
            >
              Prescription{" "}
            </Div>

            <Div
              background="transparent "
              padding="14px 20px"
              cursor="pointer"
              borderBottom={
                activeTab === "RefillRequest" ? "2px solid #2C7BE5" : "none"
              }
              fontWeight={activeTab === "RefillRequest" ? "600" : "400"}
              onClick={() => setActiveTab("RefillRequest")}
            >
              Refill Request{" "}
            </Div>
          </Div>

          {/* Content */}
          <Div height="calc(100% - 60px)" background="transparent ">
            {activeTab === "Prescription" && (
              <PrescriptionTab
                key="Prescription"
                onScheduleClick={() => setShowAddModal(true)}
              />
            )}

            {activeTab === "RefillRequest" && (
              <RefillRequest
                key="past"
                onScheduleClick={() => setShowAddModal(true)}
              />
            )}
          </Div>

          {/* Temporary Testing Section (now correctly placed inside) */}
          {/* <div
            style={{
              display: "flex",
              gap: "24px",
              marginTop: "10px",
              borderTop: "1px solid #E5E7EB",
              paddingTop: "10px",
            }}
          >
            <h1>testing</h1>
          </div> */}
        </BodyContainer>
      )}
    </>
  );
};

export default Prescription;
